<div *ngIf="this.loader==false">
    <p-toast></p-toast>
    <div class="ui-g-12">
        <div class="card card-w-title">

            <p-tabView (onChange)="onTabChange($event)">
                <div *ngIf="this.assignPatients">
                    <p-tabPanel header="Assign a Patient a Doctor" leftIcon="fa fa-check">
                        <div class="ui-g">
                            <div class="ui-g-12">
                                <div class="ui-g">
                                    <div class="ui-g-12 ui-lg-2">
                                        <label>Sort By:</label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-4">
                                        <p-dropdown id="order_by" [(ngModel)]="this.sort.sort_selected"
                                            placeholder="Select" [options]="this.sort.sort_options" #order_by="ngModel"
                                            name="order_by" (ngModelChange)="getPendingListData()" required>
                                        </p-dropdown>
                                    </div>

                                </div>

                            </div>
                            <div class="ui-g-12 text-center">
                                <app-loading *ngIf="this.loading" type="LOADING_DATA"></app-loading>
                            </div>
                        </div>
                        <div class="mat-elevation-z8">
                            <div class="table-responsive text-center justify-content-center"
                                style="font-size:14px; margin-bottom: 20px;text-align: center;vertical-align: center;">
                                <ng-container *ngIf="!this.loading && this.table_response.success">
                                    <p-table #dt [value]="pendings_list" dataKey="id" styleClass="p-datatable-sm "
                                        [rows]="10" [paginator]="true" [showCurrentPageReport]="true"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [rowsPerPageOptions]="[10,25,50]"
                                        [globalFilterFields]='this.pending_list_columns' [scrollable]="true">
                                        <ng-template pTemplate="caption">
                                            <div class="table-header">

                                                <span class="p-input-icon-left table-search-span">

                                                    <input pInputText type="text"
                                                        (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                        placeholder=" Search" class="table-search" />
                                                </span>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th pSortableColumn=" " style="width: 100px;">
                                                    <b>Patient View</b>
                                                </th>
                                                <th pSortableColumn=" " style="width: 100px;">
                                                    <b>Assign Doctor</b>
                                                </th>
                                                <!-- <th pSortableColumn=" " style="width: 100px;">
                                                    <b>Patient View</b>
                                                </th> -->
                                                <th pSortableColumn="speciality"><b>Speciality</b>
                                                    <p-sortIcon field="speciality"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="reqno"><b>Req No</b>
                                                    <p-sortIcon field="reqno"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="date_requested"><b>Date Requested</b>
                                                    <p-sortIcon field="date_requested"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="patientName"><b>Patient Name</b>
                                                    <p-sortIcon field="patientName"></p-sortIcon>
                                                </th>

                                                <th pSortableColumn="mrn" style="width: 100px;"><b>MRN</b>
                                                    <p-sortIcon field="mrn"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="age" style="width: 100px;"><b>Age</b>
                                                    <p-sortIcon field="age"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="opinion_type"><b>Opinion Type</b>
                                                    <p-sortIcon field="opinion_type"></p-sortIcon>
                                                </th>

                                                <th pSortableColumn="country"><b>Country</b>
                                                    <p-sortIcon field="country"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="state"><b>State</b>
                                                    <p-sortIcon field="state"></p-sortIcon>
                                                </th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-pendings_list>
                                            <tr [pSelectableRow]="pendings_list">
                                                <td style="width: 100px;">
                                                    <button pButton label="Open" type="button "
                                                        class="btn btn-primary btn-sm btn-space"
                                                        [routerLink] = "'patient-view/' + pendings_list.patient_guid + '/' + pendings_list.consultation_id">
                                                    </button>
                                                </td>
                                                <td style="width: 100px;">
                                                    <button pButton type="button"
                                                        class="btn btn-success btn-sm btn-space"
                                                        (click)="open_assign_Doctor_Modal(pendings_list); "
                                                        label="Open">
                                                    </button>
                                                </td>
                                                <!-- <td style="width: 100px;">
                                                    <button pButton label="Open" type="button "
                                                    class="btn btn-primary btn-sm btn-space"
                                                    [routerLink]="'patient-view/' + pendings_list.patient_guid + '/' + pendings_list.consultation_id">
                                                </button>
                                                </td> -->
                                                <td>
                                                    <span *ngFor="let sp of pendings_list.speciality">
                                                        <p-message severity="success" text="{{sp}}"></p-message>
                                                    </span>
                                                    <ng-container *ngIf="this.show_specialty_change">
                                                        <hr style="height: 2px;margin: 0px;">
                                                        <a>
                                                            <p class="show_click"
                                                                style="color:blue;font-weight: bolder;"
                                                                (click)="this.changeSpecility(pendings_list)">Change</p>
                                                        </a>
                                                    </ng-container>
                                                </td>
                                                <td>
                                                    {{pendings_list.reqno}}
                                                </td>
                                                <td>
                                                    <span>{{pendings_list.date_requested | date:'medium'}}</span>
                                                </td>
                                                <td>
                                                    <span class="notranslate">{{pendings_list.patientName}}</span>
                                                </td>
                                                <td style="width: 100px;">
                                                    <span class="notranslate">{{pendings_list.mrn}}</span>
                                                </td>
                                                <td style="width: 100px;">
                                                    <span class="notranslate">{{pendings_list.age}}</span>
                                                </td>
                                                <td>
                                                    <span>{{pendings_list.opinion_type}}</span>
                                                </td>
                                                <td>
                                                    <span class="notranslate">{{pendings_list.country}}</span>
                                                </td>
                                                <td>
                                                    <span class="notranslate">{{pendings_list.state}}</span>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="4">No Patient List Found.</td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="paginatorleft">
                                        </ng-template>
                                        <ng-template pTemplate="paginatorright">
                                        </ng-template>
                                    </p-table>
                                </ng-container>
                                <div class="row container justify-content-center text-center alert alert-danger"
                                    *ngIf="this.table_response.success!=null && this.table_response.success==false">
                                    <p *ngIf="this.table_response.error!=null">{{this.table_response.error.message}}</p>
                                    <div
                                        *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode!=500">
                                        <p *ngFor="let message of this.table_serverError?.message">{{message}}</p>
                                    </div>
                                    <div
                                        *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode==500">
                                        <p>{{this.table_serverError?.message}}</p>
                                    </div>
                                </div>

                                <p-dialog *ngIf="changeSpeciality_dialog" [(visible)]="changeSpeciality_dialog"
                                    optionLabel="label" (onHide)="closeChangeSpecility()"
                                    [contentStyle]="{height:'350px'}" [style]="{width: '50vw'}"
                                    header="Update Specialty" [baseZIndex]="10000">
                                    <div class="ui-g-12">
                                        <div class="ui-g-12 ui-md-4">
                                            <label for="speciality">Speciality<span class="req"
                                                    style="color: crimson">*</span></label>
                                        </div>
                                        <div class="ui-g-12 ui-md-8">
                                            <p-multiSelect id="speciality" [options]="specialities"
                                                optionLabel="specialty_name" name="speciality" [filter]="true"
                                                [(ngModel)]="selectedSpeciality" placeholder="Select"
                                                #speciality="ngModel" required></p-multiSelect>
                                            <div *ngIf="speciality.invalid && (speciality.dirty || speciality.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="speciality.errors.required" class="invalid">
                                                    Speciality is required.
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="row container justify-content-center text-center alert alert-danger"
                                        *ngIf="response.success!=null && response.success==false">
                                        <p *ngIf="response.error!=null">{{response.error.message}}</p>
                                        <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
                                            <p *ngFor="let message of serverError?.message">{{message}}</p>
                                        </div>
                                        <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
                                            <p>{{serverError?.message}}</p>
                                        </div>
                                    </div>
                                    <p-footer>
                                        <p-progressSpinner *ngIf="this.posting==true"
                                            [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}"
                                            strokeWidth="6">
                                        </p-progressSpinner>
                                        <button pButton type="button" class="ui-button-success" label="Assign"
                                            icon="pi pi-save"
                                            [disabled]="this.selectedSpeciality==null  || this.posting==true"
                                            (click)="updateSpecilaity()"></button>
                                        <button pButton type="button" class="ui-button-warning" label="Cancel"
                                            [disabled]="this.posting==true" icon="pi pi-times"
                                            (click)="closeChangeSpecility()"></button>
                                    </p-footer>
                                </p-dialog>

                                <p-dialog [(visible)]="displayAppointmentModification" optionLabel="label"
                                    (onHide)="closeAssignDoctor()" [contentStyle]="{height:'500px'}"
                                    [style]="{width: '50vw'}" header="Assign a Doctor" [baseZIndex]="10000">

                                    <div class="ui-g-12">
                                        <div class="card no-margin">

                                            <div>

                                                <div class="ui-g">
                                                    <div class="ui-g-12 form-group">
                                                        <div class="ui-g-12">
                                                            <div class="ui-g-12">
                                                                <label>
                                                                    <b>Notify Patient and Doctor?</b><span class="req"
                                                                        style="color: crimson">*</span>
                                                                </label>
                                                            </div>
                                                            <div class="ui-g-12">

                                                                <div class="ui-g-6">
                                                                    <p-radioButton name="shouldnotify" [value]="true"
                                                                        inputId="yes"
                                                                        [(ngModel)]="assignDoctorData.shouldNotify"></p-radioButton>
                                                                    <label for="yes">Yes</label>
                                                                </div>
                                                                <div class="ui-g-6">
                                                                    <p-radioButton name="shouldnotify" [value]="false"
                                                                        inputId="no"
                                                                        [(ngModel)]="assignDoctorData.shouldNotify"></p-radioButton>
                                                                    <label for="no">No</label>
                                                                </div>
                                                            </div>
                                                            <div class="ui-g-12">
                                                                <label for="Doctor Referred Timings">
                                                                    <b>Select a Time Slot</b><span class="req"
                                                                        style="color: crimson">*</span>
                                                                </label>
                                                            </div>
                                                            <div class="ui-g-12">
                                                                <p-progressSpinner *ngIf="!this.getDoctorScheduleResult"
                                                                    [style]="{width: '25px', height: '25px'}"
                                                                    strokeWidth="6">
                                                                </p-progressSpinner>
                                                                <p-dropdown id="DoctorSchedule"
                                                                    placeholder="Select a Doctor Schedule"
                                                                    [options]="schedules"
                                                                    (onChange)="onChangeDefaultTimings()"
                                                                    optionLabel='date' [style]="{width: '600px'}"
                                                                    [disabled]="!this.getDoctorScheduleResult"
                                                                    [(ngModel)]="selected_defualt_slot_id"
                                                                    [filter]="true"
                                                                    [ngModelOptions]="{standalone: true}" required>
                                                                </p-dropdown>
                                                                <div style="color: red;padding-top:5px;"
                                                                    *ngIf="this.getDoctorScheduleResult">
                                                                    <div *ngIf="this.schedules.length==0">
                                                                        No Schedules Available
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div class="ui-g" *ngIf="this.doctorAvailabilityResults">
                                                    <div class="ui-g-12 form-group">
                                                        <div class="ui-g-12 ">
                                                            <div class="ui-g-12">
                                                                <label for="Doctor"><b>Doctor</b><span class="req"
                                                                        style="color: crimson">*</span></label>
                                                            </div>
                                                            <div class="ui-g-12"
                                                                *ngFor="let data  of this.doctor_list_data;let i = index">
                                                                <div style="width:600px">
                                                                    <p>{{i+1}}. {{data.speciality_name}}</p>

                                                                    <p-progressSpinner
                                                                        *ngIf="!this.doctorAvailabilityResults"
                                                                        [style]="{width: '25px', height: '25px'}"
                                                                        strokeWidth="6">
                                                                    </p-progressSpinner>
                                                                    <p-dropdown id="Doctor"
                                                                        placeholder="Select a Doctor"
                                                                        [options]="data.selected_available_doctor_list"
                                                                        [disabled]="!this.doctorAvailabilityResults"
                                                                        [(ngModel)]="this.multi_selected_available_doctor[i]"
                                                                        [filter]="true"
                                                                        [ngModelOptions]="{standalone: true}" required>
                                                                    </p-dropdown>
                                                                    <div style="color: red;padding-top:5px;"
                                                                        *ngIf="this.doctorAvailabilityResults">
                                                                        <div
                                                                            *ngIf="data.selected_available_doctor_list.length==0">
                                                                            No Doctors Available
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ui-g" *ngIf="this.displayAppointmentModification">
                                                <div class="ui-g-12 form-group">
                                                    <ng-container *ngIf="this.showVendorName">
                                                        <div class="ui-g-12">
                                                            <p>
                                                                <b>Vendor Consultation</b>
                                                            </p>
                                                            <p>
                                                                Vendor Name : {{this.vendorName}}
                                                            </p>
                                                        </div>
                                                    </ng-container>
                                                    <div class="ui-g-12">
                                                        <b>Patient Slots:</b>
                                                        <div class="ui-g-12">
                                                            <ng-container
                                                                *ngIf='this.is_slot_doctor_choose; else showSlots'>
                                                                <div>
                                                                    Doctor Will Choose the Slots
                                                                </div>
                                                            </ng-container>
                                                            <div class="ui-g">
                                                                <div class="text-center">
                                                                    <ng-template #showSlots>
                                                                        <ng-container
                                                                            style="justify-content:center !important;"
                                                                            *ngIf="this.slots_date.preferred_slot_time!=null; else showPatientSlots">
                                                                            <table border="1"
                                                                                style="border:1px solid black;margin-left:13rem;">
                                                                                <tr>
                                                                                    <th>
                                                                                        Patient Preferred Slot Time
                                                                                    </th>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>
                                                                                        {{this.slots_date.preferred_slot_time}}
                                                                                    </td>
                                                                                </tr>
                                                                            </table>
                                                                        </ng-container>
                                                                        <ng-template #showPatientSlots>
                                                                            <div>
                                                                                <table border="1"
                                                                                    style="border:1px solid black;">
                                                                                    <tr>
                                                                                        <th></th>
                                                                                        <th>
                                                                                            Patient Timings
                                                                                        </th>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <th>
                                                                                            From
                                                                                        </th>
                                                                                        <td>
                                                                                            {{this.slots_date.slot1_primary_from}}
                                                                                        </td>

                                                                                    </tr>
                                                                                    <tr>
                                                                                        <th>
                                                                                            To
                                                                                        </th>
                                                                                        <td>
                                                                                            {{this.slots_date.slot1_primary_to}}
                                                                                        </td>
                                                                                    </tr>
                                                                                </table>
                                                                            </div>
                                                                        </ng-template>
                                                                    </ng-template>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ui-g" *ngIf="selected_preferred_dietician">
                                                <div class="ui-g form-group" style="width:100%">
                                                    <div class="ui-g-12 ">
                                                        Preferred Dietician:
                                                        <p>{{selected_preferred_dietician}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row container justify-content-center text-center alert alert-danger"
                                                *ngIf="response.success!=null && response.success==false">
                                                <p *ngIf="response.error!=null">{{response.error.message}}</p>
                                                <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
                                                    <p *ngFor="let message of serverError?.message">{{message}}</p>
                                                </div>
                                                <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
                                                    <p>{{serverError?.message}}</p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>


                                    <p-footer>
                                        <p-progressSpinner *ngIf="this.posting==true"
                                            [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}"
                                            strokeWidth="6">
                                        </p-progressSpinner>
                                        <button pButton type="button" class="ui-button-success" label="Assign"
                                            icon="pi pi-save" [disabled]="getDisabledConditionBoolean('ASSIGN')"
                                            (click)="assign_doctor()"></button>
                                        <button pButton type="button" class="ui-button-warning" label="Cancel"
                                            [disabled]="this.posting==true" icon="pi pi-times"
                                            (click)="closeAssignDoctor()"></button>
                                    </p-footer>

                                </p-dialog>
                                <div *ngIf="this.viewProfileDialog">
                                    <p-dialog [(visible)]="this.viewProfileDialog" optionLabel="label"
                                        (onHide)="close_view_profile()" [contentStyle]="{height:'100%'}"
                                        [style]="{width: '98vw'}"
                                        header="Health Summary and Past eGlobalDoctors Consultation"
                                        [baseZIndex]="1000">
                                        <app-patient-profile [patient_guid]='this.view_profile_patient_guid'
                                            [consultation_id]='this.view_profile_consultation_id'></app-patient-profile>
                                        <p-footer>
                                            <button pButton type="button" label="Close" (click)="close_view_profile()"
                                                class="p-button btn btn-primary btn-default"></button>
                                        </p-footer>
                                    </p-dialog>
                                </div>
                            </div>
                        </div>
                        <div class="row container justify-content-center text-center alert alert-danger"
                            *ngIf="this.table_response.success!=null && this.table_response.success==false">
                            <p *ngIf="this.table_response.error!=null">{{this.table_response.error.message}}</p>
                            <div *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode!=500">
                                <p *ngFor="let message of this.table_serverError?.message">{{message}}</p>
                            </div>
                            <div *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode==500">
                                <p>{{this.table_serverError?.message}}</p>
                            </div>

                        </div>
                    </p-tabPanel>
                </div>


                <div *ngIf="this.myPatients">
                    <p-tabPanel header="My Patients" leftIcon="fa fa-check">
                        <div class="ui-g">
                            <div class="ui-g-12">
                                <div class="ui-g">
                                    <div class="ui-g-12 ui-lg-2">
                                        <label>Consultation Status:</label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-4">
                                        <p-dropdown id="consultation_status"
                                            [(ngModel)]="my_patients_appointment_Get_Query.consultation_status"
                                            placeholder="Select" [options]="appt_status_select_item"
                                            #consultation_status="ngModel" name="consultation_status"
                                            (ngModelChange)="getMyPatientsListData()">
                                        </p-dropdown>
                                    </div>

                                </div>

                            </div>
                            <div class="ui-g">
                                <div class="ui-g-12 text-center">
                                    <app-loading *ngIf="this.loading1" type="LOADING_DATA"></app-loading>
                                </div>
                            </div>
                        </div>
                        <div class="mat-elevation-z8">
                            <div class="table-responsive text-center justify-content-center"
                                style="font-size:14px; margin-bottom: 20px;text-align: center;vertical-align: center;">
                                <ng-container *ngIf="!this.loading1 && this.table_response.success">
                                    <p-table #dt1 [value]="my_patients" dataKey="id" styleClass="p-datatable-sm "
                                        [rows]="10" [paginator]="true" [showCurrentPageReport]="true"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [rowsPerPageOptions]="[10,25,50]" [globalFilterFields]="[ 
                                    'status',
                                    'reqno',
                                    'date_requested',
                                    'patientName',
                                    'mrn',
                                    'age',
                                    'opinion_type',
                                    'speciality',
                                    'country',
                                    'state',
                                    'city',
                                    'consultation_date',
                                    'doctor'
                                    ]" [scrollable]="true">
                                        <!-- [scrollable]="true" -->
                                        <ng-template pTemplate="caption">
                                            <div class="table-header float-right">

                                                <div class="ui-table-globalfilter-container">
                                                    <input type="text" pInputText size="50" placeholder="Search"
                                                        (input)="dt1.filterGlobal($event.target.value, 'contains')"
                                                        style="width:250px;margin-left:75%;">
                                                </div>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th pSortableColumn=" " style="width: 100px;"><b>Patient Profile</b>
                                                </th>
                                                <th pSortableColumn=" " style="width: 100px;"
                                                    *ngIf="my_patients_appointment_Get_Query.consultation_status!='CLOSED'">
                                                    <b>Initiate</b>
                                                </th>
                                                <th pSortableColumn=" " style="width: 100px;"><b>Consent Status</b>
                                                </th>
                                                <th pSortableColumn=" " style="width: 100px;">
                                                    <b>Share Link</b>
                                                </th>
                                                <th pSortableColumn="status" style="width: 130px;"><b>Status</b>
                                                    <p-sortIcon field="status"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="reqno"><b>Req No</b>
                                                    <p-sortIcon field="reqno"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="date_requested"><b>Date Requested</b>
                                                    <p-sortIcon field="date_requested"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="patientName"><b>Patient Name</b>
                                                    <p-sortIcon field="patientName"></p-sortIcon>
                                                </th>

                                                <th pSortableColumn="mrn" style="width: 100px;"><b>MRN</b>
                                                    <p-sortIcon field="mrn"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="age" style="width: 100px;"><b>Age</b>
                                                    <p-sortIcon field="age"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="opinion_type"><b>Opinion Type</b>
                                                    <p-sortIcon field="opinion_type"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="consultations_left">
                                                    <b>{{(my_patients_appointment_Get_Query.consultation_status=='CLOSED')
                                                        ?'Consultations Closed':'No. of Consultations left'}}</b>
                                                </th>
                                                <th pSortableColumn="speciality"><b>Speciality</b>
                                                    <p-sortIcon field="speciality"></p-sortIcon>
                                                </th>

                                                <th pSortableColumn="country"><b>Country</b>
                                                    <p-sortIcon field="country"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="state"><b>State</b>
                                                    <p-sortIcon field="state"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="doctor"><b>Doctor</b>
                                                    <p-sortIcon field="doctor"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="consultation_date"><b>Appointment Date</b>
                                                    <p-sortIcon field="consultation_date"></p-sortIcon>
                                                </th>

                                            </tr>

                                        </ng-template>
                                        <ng-template pTemplate="body" let-my_patients>
                                            <tr [pSelectableRow]="my_patients">
                                                <td style="width: 100px;">
                                                    <button pButton type="button"
                                                        class="btn btn-success btn-sm btn-space "
                                                        (click)="open_view_profile('my_patients',my_patients.patient_guid,my_patients.consultation_id)"
                                                        label="View">
                                                    </button>
                                                </td>
                                                <td style="width: 100px;"
                                                    *ngIf="my_patients_appointment_Get_Query.consultation_status!='CLOSED'">
                                                    <div *ngIf="my_patients.status=='SCHEDULED'">
                                                        <span><button pButton label="Open" type="button "
                                                                class="btn btn-primary btn-sm btn-space"
                                                                [routerLink] = "'patient-view/' + my_patients.patient_guid + '/' + my_patients.consultation_id">
                                                            </button></span>
                                                    </div>
                                                    <div *ngIf="my_patients.status=='IN PROGRESS'">
                                                        <span><button pButton label="Open" type="button "
                                                                class="btn btn-primary btn-sm btn-space"
                                                                [routerLink] = "'patient-view/' + my_patients.patient_guid + '/' + my_patients.consultation_id">
                                                            </button></span>
                                                    </div>
                                                </td>
                                                <td style="width: 100px;">
                                                    <span>
                                                        <button pButton type="button"
                                                            class="btn btn-success btn-sm btn-space "
                                                            (click)="showDialog1(my_patients)" label="Consent Update">
                                                        </button>
                                                    </span>
                                                    <ng-template #notapplicable>
                                                        No Consent
                                                    </ng-template>
                                                </td>
                                                <td style="width: 100px;">
                                                    <button pButton label="Share" type="button "
                                                        class="btn btn-primary btn-sm btn-space"
                                                        [disabled]="this.share_loader"
                                                        (click)="open_share(my_patients.consultation_id,my_patients.patient_guid,my_patients.doctor_user_guid[0]);">
                                                    </button>
                                                </td>
                                                <td style="width: 130px;">
                                                    <span>{{my_patients.status}}</span>
                                                </td>
                                                <td>
                                                    {{my_patients.reqno}}
                                                </td>
                                                <td>
                                                    <span>{{my_patients.date_requested | date:'medium'}}</span>
                                                </td>
                                                <td>
                                                    <span>{{my_patients.patientName}}</span>
                                                </td>
                                                <td style="width: 100px;">
                                                    <span>{{my_patients.mrn}}</span>
                                                </td>
                                                <td style="width: 100px;">

                                                    <span>{{my_patients.age}}</span>
                                                </td>
                                                <td>
                                                    <span>{{my_patients.opinion_type}}</span>
                                                </td>
                                                <td>
                                                    <span>{{my_patients.consultations_left}}</span>
                                                </td>
                                                <td>
                                                    <span *ngFor="let sp of my_patients.speciality">
                                                        <p-message severity="success" text="{{sp}}"></p-message>
                                                    </span>
                                                </td>
                                                <td>
                                                    <span>{{my_patients.country}}</span>
                                                </td>
                                                <td>
                                                    <span>{{my_patients.state}}</span>
                                                </td>
                                                <td>
                                                    <span *ngFor="let sp of my_patients.doctor">
                                                        <p-message severity="success" text="{{sp}}"></p-message>
                                                    </span>
                                                </td>
                                                <td>
                                                    <span>{{my_patients.consultation_date | date:'medium'}}</span>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="4">No Patient List Found.</td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="paginatorleft">
                                        </ng-template>
                                        <ng-template pTemplate="paginatorright">
                                        </ng-template>
                                    </p-table>
                                </ng-container>
                                <div class="row container justify-content-center text-center alert alert-danger"
                                    *ngIf="this.table_response.success!=null && this.table_response.success==false">
                                    <p *ngIf="this.table_response.error!=null">{{this.table_response.error.message}}</p>
                                    <div
                                        *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode!=500">
                                        <p *ngFor="let message of this.table_serverError?.message">{{message}}</p>
                                    </div>
                                    <div
                                        *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode==500">
                                        <p>{{this.table_serverError?.message}}</p>
                                    </div>
                                </div>
                                <div *ngIf="this.viewProfileDialog">
                                    <p-dialog [(visible)]="this.viewProfileDialog" optionLabel="label"
                                        [contentStyle]="{height:'100%'}" (onHide)="close_view_profile()"
                                        [style]="{width: '98vw'}"
                                        header="Health Summary and Past eGlobalDoctors Consultation"
                                        [baseZIndex]="1000">
                                        <app-patient-profile [patient_guid]='this.view_profile_patient_guid'
                                            [consultation_id]='this.view_profile_consultation_id'></app-patient-profile>
                                        <p-footer>
                                            <button pButton type="button" label="Close" (click)="close_view_profile()"
                                                class="p-button btn btn-primary btn-default"></button>
                                        </p-footer>
                                    </p-dialog>
                                </div>
                            </div>
                        </div>


                        <p-dialog [(visible)]="display" header="Update Consent Status" [style]="{width: '30vw'}"
                            [resizable]=true [contentStyle]="{'height': '350px' ,'overflow':'visible'}">
                            <div style="margin-bottom: 10px;">
                                <label style="margin-right: 105px;font-weight: bold;">Status</label>
                                <p-toggleButton id="status" [(ngModel)]="this.close_consent"
                                    [style]="{'width':'50%','border-radius':'50rem'}" onLabel="Consented"
                                    offLabel="Not Consented" [onIcon]="'pi pi-check'"
                                    offIcon="pi pi-times"></p-toggleButton>
                            </div>
                            <div style="margin-top: 50px;margin-bottom: 10px;">
                                <label style="margin-right: 50px;font-weight: bold;">Update</label>

                                <p-button icon="pi pi-check" (click)="updateConsent()" label="Update"
                                    styleClass="p-button-text"></p-button>
                            </div>
                            <div>
                                <span class="red-req">{{this.update_msg}}</span>
                            </div>
                        </p-dialog>

                        <p-dialog header="Share Communication Link" [contentStyle]="{'height':'500px'}"
                            [style]="{'width':'80vw'}" (onHide)="closeShareDialog()" [resizable]="true"
                            [responsive]="true" [(visible)]="this.share_dialog">
                            <app-share-message-doctors *ngIf="this.share_dialog" [messageString]="this.message"
                                (onGetLink)="getToken($event)" (dialogChange)="closeShare($event)">
                            </app-share-message-doctors>
                            <div class="row container justify-content-center text-center alert alert-danger"
                                *ngIf="response.success!=null && response.success==false">
                                <p *ngIf="response.error!=null">{{response.error.message}}</p>
                                <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
                                    <p *ngFor="let message of serverError?.message">{{message}}</p>
                                </div>
                                <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
                                    <p>{{serverError?.message}}</p>
                                </div>
                            </div>
                        </p-dialog>
                    </p-tabPanel>
                </div>
                <div *ngIf="this.reassign">
                    <p-tabPanel header="Reassign/Reschedule" leftIcon="fa fa-check">

                        <div class="ui-g">
                            <div class="ui-g-12 text-center">
                                <app-loading *ngIf="this.loading4" type="LOADING_DATA"></app-loading>
                            </div>
                        </div>

                        <div class="mat-elevation-z8">
                            <div class="table-responsive text-center justify-content-center"
                                style="font-size:14px; margin-bottom: 20px;text-align: center;vertical-align: center;">
                                <ng-container *ngIf="!this.loading4 && this.table_response.success">
                                    <p-table #dta1 [value]="all_assigned_patients" dataKey="id"
                                        styleClass="p-datatable-sm " [rows]="10" [paginator]="true"
                                        [showCurrentPageReport]="true"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [rowsPerPageOptions]="[10,25,50]" [globalFilterFields]="[ 
                                        'status',
                                        'reqno',
                                        'date_requested',
                                        'patientName',
                                        'mrn',
                                        'age',
                                        'opinion_type',
                                        'speciality',
                                        'country',
                                        'state',
                                        'city',
                                        'doctor',
                                        'consultation_date'
                                        ]" [scrollable]="true">
                                        <!-- [scrollable]="true" -->
                                        <ng-template pTemplate="caption">
                                            <div class="table-header float-right">

                                                <div class="ui-table-globalfilter-container">
                                                    <input type="text" pInputText size="50" placeholder="Search"
                                                        (input)="dta1.filterGlobal($event.target.value, 'contains')"
                                                        style="width:250px;margin-left:75%;">
                                                </div>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th pSortableColumn="" style="width: 100px;">
                                                    <b>Patient Profile</b>
                                                </th>
                                                <th pSortableColumn=" " style="width: 100px;">
                                                    <b>Reassign Doctor</b>
                                                </th>
                                                <th pSortableColumn=" " style="width: 130px;">
                                                    <b>Reschedule Appointment</b>
                                                </th>
                                                <th pSortableColumn=" " style="width: 100px;">
                                                    <b>History</b>
                                                </th>
                                                <th pSortableColumn="status" style="width: 130px;"><b>Status</b>
                                                    <p-sortIcon field="status"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="reqno"><b>Req No</b>
                                                    <p-sortIcon field="reqno"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="date_requested"><b>Date Requested</b>
                                                    <p-sortIcon field="date_requested"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="patientName"><b>Patient Name</b>
                                                    <p-sortIcon field="patientName"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="mrn" style="width: 100px;"><b>MRN</b>
                                                    <p-sortIcon field="mrn"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="age" style="width: 100px;"><b>Age</b>
                                                    <p-sortIcon field="age"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="opinion_type"><b>Opinion Type</b>
                                                    <p-sortIcon field="opinion_type"></p-sortIcon>
                                                </th>

                                                <th pSortableColumn="speciality"><b>Speciality</b>
                                                    <p-sortIcon field="speciality"></p-sortIcon>
                                                </th>

                                                <th pSortableColumn="country"><b>Country</b>
                                                    <p-sortIcon field="country"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="state"><b>State</b>
                                                    <p-sortIcon field="state"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="doctor"><b>Doctor</b>
                                                    <p-sortIcon field="doctor"></p-sortIcon>
                                                </th>

                                                <th pSortableColumn="consultation_date"><b>Appointment Date</b>
                                                    <p-sortIcon field="consultation_date"></p-sortIcon>
                                                </th>

                                            </tr>

                                        </ng-template>
                                        <ng-template pTemplate="body" let-all_patients>
                                            <tr [pSelectableRow]="all_patients">
                                                <td style="width: 100px;">
                                                    <button pButton type="button"
                                                        class="btn btn-success btn-sm btn-space "
                                                        (click)="open_view_profile('all_assigned_patients',all_patients.patient_guid,all_patients.consultation_id)"
                                                        label="View">
                                                    </button>
                                                </td>
                                                <td style="width: 100px;">
                                                    <span><button pButton label="Open" type="button "
                                                            class="btn btn-primary btn-sm btn-space"
                                                            (click)="open_reassign_modal(all_patients);">
                                                        </button></span>
                                                </td>
                                                <td style="width: 130px;">
                                                    <span><button pButton label="Open" type="button "
                                                            class="btn btn-primary btn-sm btn-space"
                                                            (click)="open_reschedule_modal(all_patients);">
                                                            <!-- Intiate -->
                                                        </button></span>
                                                </td>
                                                <td class="tdentry" style="width: 100px;">
                                                    <button pButton label="View" [disabled]="this.history_posting"
                                                        (click)="getConsultationsHistoryData(all_patients)"></button>
                                                </td>
                                                <td style="width: 130px;">
                                                    <span>{{all_patients.status}}</span>
                                                </td>
                                                <td>
                                                    {{all_patients.reqno}}
                                                </td>
                                                <td>

                                                    <span>{{all_patients.date_requested | date:'medium'}}</span>
                                                </td>
                                                <td>

                                                    <span>{{all_patients.patientName}}</span>
                                                </td>
                                                <td style="width: 100px;">

                                                    <span>{{all_patients.mrn}}</span>
                                                </td>
                                                <td style="width: 100px;">

                                                    <span>{{all_patients.age}}</span>
                                                </td>
                                                <td>

                                                    <span>{{all_patients.opinion_type}}</span>
                                                </td>

                                                <td>

                                                    <span *ngFor="let sp of all_patients.speciality">
                                                        <p-message severity="success" text="{{sp}}"></p-message>
                                                    </span>
                                                </td>

                                                <td>

                                                    <span>{{all_patients.country}}</span>
                                                </td>
                                                <td>

                                                    <span>{{all_patients.state}}</span>
                                                </td>
                                                <td>
                                                    <span *ngFor="let sp of all_patients.doctor">
                                                        <p-message severity="success" text="{{sp}}"></p-message>
                                                    </span>
                                                </td>

                                                <td>
                                                    <span>{{all_patients.consultation_date | date:'medium'}}</span>
                                                </td>



                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="4">No Patient List Found.</td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="paginatorleft">
                                        </ng-template>
                                        <ng-template pTemplate="paginatorright">
                                        </ng-template>
                                    </p-table>
                                </ng-container>
                                <div class="row container justify-content-center text-center alert alert-danger"
                                    *ngIf="this.table_response.success!=null && this.table_response.success==false">
                                    <p *ngIf="this.table_response.error!=null">{{this.table_response.error.message}}</p>
                                    <div
                                        *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode!=500">
                                        <p *ngFor="let message of this.table_serverError?.message">{{message}}</p>
                                    </div>
                                    <div
                                        *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode==500">
                                        <p>{{this.table_serverError?.message}}</p>
                                    </div>

                                </div>
                                <div *ngIf="this.viewProfileDialog">
                                    <p-dialog [(visible)]="this.viewProfileDialog" optionLabel="label"
                                        (onHide)="close_view_profile()" [contentStyle]="{height:'100%'}"
                                        [style]="{width: '98vw'}"
                                        header="Health Summary and Past eGlobalDoctors Consultation"
                                        [baseZIndex]="1000">
                                        <app-patient-profile [patient_guid]='this.view_profile_patient_guid'
                                            [consultation_id]='this.view_profile_consultation_id'></app-patient-profile>
                                        <p-footer>
                                            <button pButton type="button" label="Close" (click)="close_view_profile()"
                                                class="p-button btn btn-primary btn-default"></button>
                                        </p-footer>
                                    </p-dialog>
                                </div>

                            </div>
                        </div>


                        <p-dialog header="Appointment History" *ngIf="historyDialog" [(visible)]="historyDialog"
                            [baseZIndex]="10000" [closable]="true" [modal]="true" [style]="{'width':'100%'}"
                            [contentStyle]="{'text-align':'center'}">

                            <app-patient-appointment-history
                                *ngIf="history_response.success!=null && history_response.success==true && history"
                                [history]="history"></app-patient-appointment-history>

                            <div class="row container justify-content-center text-center alert alert-danger"
                                *ngIf="history_response.success!=null && history_response.success==false">
                                <p *ngIf="history_response.error!=null">{{history_response.error.message}}</p>
                                <div *ngIf="history_serverError?.error!=null && history_serverError?.statusCode!=500">
                                    <p *ngFor="let message of history_serverError?.message">{{message}}</p>
                                </div>
                                <div *ngIf="history_serverError?.error!=null && history_serverError?.statusCode==500">
                                    <p>{{history_serverError?.message}}</p>
                                </div>

                            </div>

                            <ng-template pTemplate="footer">
                                <p-button icon="pi pi-check" (click)="historyDialog=false;" label="Close"
                                    styleClass="p-button-text"></p-button>
                            </ng-template>
                        </p-dialog>

                        <p-dialog [(visible)]="displayReassign" optionLabel="label" [contentStyle]="{height:'600px'}"
                            (onHide)="closeReassignDoctor()" [style]="{width: '70vw'}" header="Reassign a Doctor"
                            [baseZIndex]="10000">

                            <div class="ui-g-12">
                                <div class="card no-margin">

                                    <div>

                                        <div class="ui-g">
                                            <div class="ui-g form-group">
                                                <div class="ui-g-12">
                                                    <div class="ui-g-12">
                                                        <label>
                                                            Notify Patient and Doctor?<span class="req"
                                                                style="color: crimson">*</span>
                                                        </label>
                                                    </div>
                                                    <div class="ui-g-12">

                                                        <div class="ui-g-6">
                                                            <p-radioButton name="shouldnotify" [value]="true"
                                                                inputId="yes"
                                                                [(ngModel)]="reassignDoctorData.shouldNotify"></p-radioButton>
                                                            <label for="yes">Yes</label>
                                                        </div>
                                                        <div class="ui-g-6">
                                                            <p-radioButton name="shouldnotify" [value]="false"
                                                                inputId="no"
                                                                [(ngModel)]="reassignDoctorData.shouldNotify"></p-radioButton>
                                                            <label for="no">No</label>
                                                        </div>
                                                    </div>
                                                    <div class="ui-g-12">
                                                        <label for="Doctor Referred Timings">
                                                            Select a Time Slot<span class="req"
                                                                style="color: crimson">*</span>
                                                        </label>
                                                    </div>
                                                    <div class="ui-g-12">
                                                        <p-progressSpinner *ngIf="!this.getDoctorScheduleResult"
                                                            [style]="{width: '25px', height: '25px'}" strokeWidth="6">
                                                        </p-progressSpinner>
                                                        <p-dropdown id="DoctorSchedule"
                                                            placeholder="Select a Doctor Schedule" [options]="schedules"
                                                            (onChange)="onChangeDefaultTimings()" optionLabel='date'
                                                            [style]="{width: '600px'}"
                                                            [disabled]="!this.getDoctorScheduleResult"
                                                            [(ngModel)]="selected_defualt_slot_id" [filter]="true"
                                                            [ngModelOptions]="{standalone: true}" required>
                                                        </p-dropdown>
                                                        <div style="color: red;padding-top:5px;"
                                                            *ngIf="this.getDoctorScheduleResult">
                                                            <div *ngIf="this.schedules.length==0">
                                                                No Schedules Available
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div class="ui-g" *ngIf="this.doctorAvailabilityResults">
                                            <div class="ui-g form-group">
                                                <div class="ui-g-12 ">
                                                    <div class="ui-g-12">
                                                        <label for="Doctor">Doctor<span class="req"
                                                                style="color: crimson">*</span></label>
                                                    </div>
                                                    <div class="ui-g-12"
                                                        *ngFor="let data  of this.doctor_list_data;let i = index">
                                                        <div style="width:600px">
                                                            <p>{{i+1}}. {{data.speciality_name}}</p>

                                                            <p-progressSpinner *ngIf="!this.doctorAvailabilityResults"
                                                                [style]="{width: '25px', height: '25px'}"
                                                                strokeWidth="6">
                                                            </p-progressSpinner>
                                                            <p-dropdown id="Doctor" placeholder="Select a Doctor"
                                                                [options]="data.selected_available_doctor_list"
                                                                [disabled]="!this.doctorAvailabilityResults"
                                                                [(ngModel)]="this.multi_selected_available_doctor[i]"
                                                                [filter]="true" [ngModelOptions]="{standalone: true}"
                                                                required>
                                                            </p-dropdown>
                                                            <div style="color: red;padding-top:5px;"
                                                                *ngIf="this.doctorAvailabilityResults">
                                                                <div
                                                                    *ngIf="data.selected_available_doctor_list.length==0">
                                                                    No Doctors Available
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="ui-g">
                                        <div class="ui-g form-group">
                                            <div class="ui-g-12 ">
                                                <div class="ui-g-12">
                                                    <label for="Reassign">Reassign Reason<span class="req"
                                                            style="color: crimson">*</span></label>
                                                </div>
                                                <div class="ui-g-12">
                                                    <div style="width:600px">

                                                        <textarea [rows]="8" [cols]="75" id="Reassign"
                                                            [pKeyFilter]="textarea"
                                                            [(ngModel)]="current_reassign_reason" name="Reassign"
                                                            placeholder="Enter your Reassign Reason here"
                                                            maxlength="500" pInputTextarea class="format-lines"
                                                            #reassign_reason="ngModel" required></textarea>
                                                        <div class="ui-g-12" style="float: left;">
                                                            <p [style.color]="current_reassign_reason.length-499>0?'red':'green'"
                                                                style="float: left;">
                                                                {{(501-current_reassign_reason.length)
                                                                <0?0:500-current_reassign_reason.length}} of 500
                                                                    left</p>

                                                        </div>
                                                    </div>
                                                    <div *ngIf="reassign_reason.invalid && (reassign_reason.dirty || reassign_reason.touched)"
                                                        class="alert alert-danger">
                                                        <div *ngIf="reassign_reason.errors.required" class="invalid">
                                                            Reassign Reason is required.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row container justify-content-center text-center alert alert-danger"
                                        *ngIf="response.success!=null && response.success==false">
                                        <p *ngIf="response.error!=null">{{response.error.message}}</p>
                                        <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
                                            <p *ngFor="let message of serverError?.message">{{message}}</p>
                                        </div>
                                        <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
                                            <p>{{serverError?.message}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p-footer>
                                <p-progressSpinner *ngIf="this.posting==true"
                                    [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}"
                                    strokeWidth="6">
                                </p-progressSpinner>
                                <button pButton type="button" class="ui-button-success" label="Reassign"
                                    icon="pi pi-save" [disabled]="getDisabledConditionBoolean('REASSIGN')"
                                    (click)="reassign_doctor()"></button>
                                <button pButton type="button" class="ui-button-warning" label="Cancel"
                                    icon="pi pi-times" (click)="closeReassignDoctor()"
                                    [disabled]="this.posting==true"></button>
                            </p-footer>
                        </p-dialog>



                        <p-dialog [(visible)]="displayReschedule" optionLabel="label" [contentStyle]="{height:'600px'}"
                            (onHide)="closeRescheduleDoctor()" [style]="{width: '70vw'}" header="Reschedule Appointment"
                            [baseZIndex]="10000">
                            <!-- <p-header>
                    Add a Condition
                </p-header> -->
                            <div class="ui-g-12">
                                <div class="card no-margin">

                                    <div class="ui-g">
                                        <div class="ui-g form-group">
                                            <div class="ui-g-12 ">
                                                <div class="ui-g-12">
                                                    <label>
                                                        Notify Patient and Doctor?<span class="req"
                                                            style="color: crimson">*</span>
                                                    </label>
                                                </div>
                                                <div class="ui-g-12">

                                                    <div class="ui-g-6">
                                                        <p-radioButton name="shouldnotify" [value]="true" inputId="yes"
                                                            [(ngModel)]="rescheduleDoctorData.shouldNotify"></p-radioButton>
                                                        <label for="yes">Yes</label>
                                                    </div>
                                                    <div class="ui-g-6">
                                                        <p-radioButton name="shouldnotify" [value]="false" inputId="no"
                                                            [(ngModel)]="rescheduleDoctorData.shouldNotify"></p-radioButton>
                                                        <label for="no">No</label>
                                                    </div>
                                                </div>
                                                <div class="ui-g-12">
                                                    <label for="Doctor Referred Timings">Doctor Schedule<span
                                                            class="req" style="color: crimson">*</span></label>
                                                </div>
                                                <div class="ui-g-12">
                                                    <p-progressSpinner *ngIf="!this.getDoctorScheduleResult"
                                                        [style]="{width: '25px', height: '25px'}" strokeWidth="6">
                                                    </p-progressSpinner>
                                                    <p-dropdown id="DoctorSchedule"
                                                        placeholder="Select a Doctor Schedule" [options]="schedules"
                                                        optionLabel='date' [style]="{width: '600px'}"
                                                        [disabled]="!this.getDoctorScheduleResult"
                                                        [(ngModel)]="selected_reschedule_doctor_schedule"
                                                        [filter]="true" [ngModelOptions]="{standalone: true}" required>
                                                    </p-dropdown>
                                                    <!-- </div> -->


                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="ui-g">
                                        <div class="ui-g form-group">
                                            <div class="ui-g-12 ">
                                                <div class="ui-g-12">
                                                    <label for="Reschedule Reason">Reschedule Reason<span class="req"
                                                            style="color: crimson">*</span></label>
                                                </div>
                                                <div class="ui-g-12">
                                                    <div style="width:600px">

                                                        <textarea [rows]="8" [cols]="75" id="Reschedule Reason"
                                                            [pKeyFilter]="textarea"
                                                            [(ngModel)]="current_reschedule_reason"
                                                            name="Reschedule Reason"
                                                            placeholder="Enter your Reschedule Reason here"
                                                            [disabled]="this.selected_reschedule_doctor_schedule==null"
                                                            maxlength="500" pInputTextarea class="format-lines"
                                                            #reschedule_reason="ngModel" required></textarea>
                                                        <div class="ui-g-12" style="float: left;">
                                                            <p [style.color]="current_reschedule_reason.length-499>0?'red':'green'"
                                                                style="float: left;">
                                                                {{(501-current_reschedule_reason.length)
                                                                <0?0:500-current_reschedule_reason.length}} of 500
                                                                    left</p>

                                                        </div>
                                                    </div>
                                                    <div style="color: red;padding-top:5px;"
                                                        *ngIf="reschedule_reason.invalid && (reschedule_reason.dirty || reschedule_reason.touched)"
                                                        class="alert alert-danger">
                                                        <div *ngIf="reschedule_reason.errors.required" class="invalid">
                                                            Reschedule Reason is required.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row container justify-content-center text-center alert alert-danger"
                                        *ngIf="response.success!=null && response.success==false">
                                        <p *ngIf="response.error!=null">{{response.error.message}}</p>
                                        <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
                                            <p *ngFor="let message of serverError?.message">{{message}}</p>
                                        </div>
                                        <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
                                            <p>{{serverError?.message}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p-footer>

                                <p-progressSpinner *ngIf="this.posting==true"
                                    [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}"
                                    strokeWidth="6">
                                </p-progressSpinner>
                                <button pButton type="button" class="ui-button-success" label="Reschedule"
                                    icon="pi pi-save"
                                    [disabled]="(this.current_reschedule_reason.length==0  || selected_reschedule_doctor_schedule==null) || this.posting==true"
                                    (click)="reschedule_doctor()"></button>
                                <button pButton type="button" class="ui-button-warning" label="Cancel"
                                    icon="pi pi-times" [disabled]="this.posting==true"
                                    (click)="closeRescheduleDoctor()"></button>
                            </p-footer>
                        </p-dialog>

                    </p-tabPanel>
                </div>

            </p-tabView>
        </div>
    </div>
</div>

<div *ngIf="loader">
    <h4>Loading</h4>
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="6"></p-progressSpinner>
</div>